interface TabsterCoreWithAttributeHandlers {
  attrHandlers?: Map<string, unknown>;
}

interface WindowWithTabster extends Window {
  __tabsterInstance?: TabsterCoreWithAttributeHandlers;
}

/**
 * Adds the extension registry expected by newer Tabster modules to the older
 * Tabster core supplied by MSX. The MSX observer continues to process the
 * registered Groupper and Mover APIs through its native attribute handling.
 */
export const ensureMsxTabsterCompatibility = (targetWindow: Window = window): void => {
  const tabsterCore = (targetWindow as WindowWithTabster).__tabsterInstance;
  if (tabsterCore && !tabsterCore.attrHandlers) {
    tabsterCore.attrHandlers = new Map<string, unknown>();
  }
};
